const moment = require('moment')

export default new class Utils {
  splitArrayToGroups (array) {
    const grouped = []
    if (array.length > 0) {
      const chunk = 3
      for (var i = 0; i < array.length; i += chunk) {
        const group = array.slice(i, i + chunk)
        grouped.push(group)
      }
    }
    return grouped
  }

  parseDate (value) {
    return moment(value)
  }

  formatDate (value) {
    return value.format('YYYY-MM-DD')
  }

  getNextDateInYears (first, last, inYears) {
    if (first === undefined || !inYears) {
      return '/'
    }
    let firstInstallation = this.parseDate(first)
    if (last) {
      const tempLast = this.parseDate(last)
      if (first == null) {
        firstInstallation = tempLast
      } else {
        if (tempLast.isAfter(firstInstallation)) {
          firstInstallation = tempLast
        }
      }
    }
    return this.parseDate(firstInstallation).add(inYears, 'years')
  }

  getNextDateInYearsFormatted (first, last, inYears) {
    const result = this.getNextDateInYears(first, last, inYears)
    if (typeof result === 'string') {
      return result
    }
    return this.formatDate(result)
  }

  isMoreThanDaysTillThen (date, days) {
    const newDate = moment(new Date()).add(days, 'days')
    const mDate = moment(date)
    return newDate.isAfter(mDate)
  }

  buildQueryString (query) {
    const params = new URLSearchParams()
    Object.keys(query).forEach((key) => {
      if (query[key]) {
        params.append(key, query[key])
      }
    })
    return params.toString()
  }
}()
